import React from "react"
import { useFilterCatalog } from "@/hooks/filterCatalog"
import { useAppDispatch } from "@/hooks/redux"
import { setIsShowAutoComplete } from "@/store/reducers/searchSlice"
import { Section } from "@/styles/utils/Utils"
import { Button } from "@/ui/Button/Button"
import { ButtonGroup } from "@/ui/Button/StyledButton"
import { Typography } from "@/ui/Typography/Typography"
import { ROUTES } from "@/utils/constants"

const EMPTY_TEXT = {
  default: "Воспользуйтесь поиском или найдите подходящую категорию в каталоге",
  filter: "Попробуйте очистить фильтры или воспользуйтесь поиском",
}
const TITLE = "Не смогли подобрать нужного"

const NotResults = () => {
  const dispatch = useAppDispatch()
  const { clearCheckedFilters, isExist } = useFilterCatalog()

  const subtitle = isExist ? EMPTY_TEXT.filter : EMPTY_TEXT.default

  return (
    <Section
      style={{
        paddingTop: 10,
      }}
    >
      <Typography variant={"h1"}>{TITLE}</Typography>
      <Typography>{subtitle}</Typography>
      <ButtonGroup>
        {isExist ? (
          <Button
            variant={"filled"}
            onClick={clearCheckedFilters}
            icon={"Rotate"}
          >
            Очистить фильтры
          </Button>
        ) : (
          <Button
            variant={"filled"}
            as={"a"}
            href={ROUTES.catalog}
            icon={"ViewBoxes"}
          >
            В каталог
          </Button>
        )}
        <Button
          variant={"outline"}
          onClick={() => {
            dispatch(setIsShowAutoComplete(true))
          }}
          icon={"Search"}
        >
          Найти
        </Button>
      </ButtonGroup>
    </Section>
  )
}

export { NotResults }
